<template>
	<Head title="Coleta de Biometria"></Head>

	<div class="container exam-capture-page">
		<div class="row align-items-center mt-10 mb-10 row-logo exam-logo-row">
			<div class="col mx-auto text-center">
				<img
					alt="Logo Habilite-se"
					src="/habil/images/logo.svg"
					class="h-35px" />
			</div>
		</div>
		<toastInfo
			:test_over="test_over"
			:test_middle="test_middle"
			:userName="props.user.name"
			:userCPF="props.user.cpf"
			:computerName="props.enrollmentTest.descricao"
			:CFCName="props.subtenantName" />
		<div class="row align-items-center row-card">
			<div class="col-sm-10 col-md-8 mx-auto">
				<div class="card">
					<div class="card-body exam-card-body">
						<div>
							<div class="text-center exam-heading">
								<h2 class="m-0">Coleta de Biometria e Foto</h2>
								<p
									class="fw-bolder fs-5 text-gray-600 exam-heading-caption">
									Leia com atenção as instruções de cada etapa
								</p>
							</div>
						</div>
						<div class="row justify-content-center text-center">
							<div class="col-md-12">
								<ul id="progressbar" class="exam-progressbar-two">
									<li
										class="active fs-5"
										id="biometria">
										<strong>Biometria</strong>
									</li>
									<li
										id="foto"
										class="fs-5">
										<strong>Coleta de Foto</strong>
									</li>
								</ul>
							</div>
						</div>

						<div
							v-if="test_over && url_message === 'test-over'"
							class="row justify-content-center px-12">
							<div
								class="alert alert-success fw-bolder"
								role="alert">
								Todas as questões foram respondidas, para
								finalizar a prova siga as instruções
							</div>
						</div>

						<div
							v-if="test_over && url_message === 'exam_timeout'"
							class="row justify-content-center px-12">
							<div
								:class="`alert alert-${url_type_message} fw-bolder`"
								role="alert">
								Seu tempo acabou, para finalizar a prova siga as
								instruções
							</div>
						</div>

						<div
							v-if="test_middle"
							class="row justify-content-center px-12">
							<div
								class="alert alert-info fw-bolder"
								role="alert">
								<span
									class="fa fa-lg fa-info-circle text-info"></span>
								Para continuar a prova é necessário realizar a
								validação biométrica
							</div>
						</div>

						<div class="exam-capture-layout">
							<section
								class="exam-instructions"
								aria-labelledby="biometry-instructions-title">
								<p class="exam-step-label">Etapa atual</p>
								<h2
									id="biometry-instructions-title"
									class="exam-instructions-title">
									Coloque o dedo no leitor
								</h2>
								<p class="exam-instructions-lead">
									Use o dedo indicado abaixo e depois clique
									no botão azul.
								</p>

								<div
									class="exam-checklist"
									role="list">
									<div
										class="exam-checklist-item"
										role="listitem">
										<span class="exam-checklist-number">
											1
										</span>
										<span>
											Posicione o dedo
										<strong>{{ fingerLabel }}</strong>
											no leitor.
										</span>
									</div>
									<div
										class="exam-checklist-item"
										role="listitem">
										<span class="exam-checklist-number">
											2
										</span>
										<span>
											Mantenha o dedo parado durante a
											captura.
										</span>
									</div>
									<div
										class="exam-checklist-item"
										role="listitem">
										<span class="exam-checklist-number">
											3
										</span>
										<span>
											Clique em
											<strong>{{
												biometryPrimaryActionLabel
											}}</strong>.
										</span>
									</div>
								</div>
							</section>

							<section
								class="exam-capture-panel"
								aria-live="polite">
								<div
									id="box-finger-image"
									class="exam-media-box blockui">
									<div
										v-if="biometryStep === 'capturing'"
										class="blockui-overlay exam-media-overlay"
										style="z-index: 1">
										<span
											class="spinner-border text-primary"></span>
									</div>
									<div
										v-if="biometryStep === 'idle'"
										id="finger-image"
										class="exam-hands-preview"
										aria-label="Imagem das duas mãos com o dedo indicado em destaque">
										<img
											:src="neutralHandsImageSrc"
											class="img-fluid exam-finger-image exam-hands-image"
											alt="" />
										<img
											:src="highlightedHandsImageSrc"
											:class="[
												'img-fluid',
												'exam-finger-image',
												'exam-hands-image',
												'exam-highlighted-hands-image',
												{
													'is-visible':
														showHighlightedHands,
												},
											]"
											alt="" />
									</div>
									<img
										v-else
										id="finger-image"
										:src="imagePath"
										class="img-fluid exam-finger-image exam-captured-finger-image"
										alt="Imagem capturada da biometria" />
								</div>

								<button
									v-if="biometryStep === 'idle'"
									@click="startBiometry"
									id="start-biometry"
									class="btn btn-primary btn-color exam-primary-action w-100">
									<span
										class="fa fa-lg fa-fingerprint"
										aria-hidden="true"></span>
									 {{ biometryPrimaryActionLabel }}
								</button>

								<button
									v-else-if="biometryStep === 'error'"
									@click="startBiometry"
									id="start-biometry"
									class="btn btn-primary btn-color exam-primary-action w-100">
									<span
										class="fa fa-lg fa-refresh"
										aria-hidden="true"></span>
									Tentar novamente
								</button>

								<div
									v-else-if="biometryStep === 'success'"
									class="exam-success-actions">
									<button
										id="submit-biometry"
										class="btn btn-primary btn-color exam-primary-action w-100"
										@click="nextPage">
										Avançar
									</button>
									<button
										id="submit-restart-process"
										class="btn btn-light-danger exam-secondary-action w-100"
										type="button"
										@click="resetBiometry">
										<span
											class="fa fa-lg fa-refresh"
											aria-hidden="true"></span>
										Refazer biometria
									</button>
								</div>

								<button
									v-else
									id="start-biometry"
									class="btn btn-primary btn-color exam-primary-action w-100"
									disabled>
									<span
										class="fa fa-lg fa-spin fa-sync"
										aria-hidden="true"></span>
									Aguarde
									{{ waitingBiometrySeconds }} segundos
								</button>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Head, router } from '@inertiajs/vue3';
import { ref, Ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import axios, { AxiosResponse } from 'axios';
import { ResponseAgentManagerBiometry } from '../../Interfaces/ResponseAgentManagerBiometry';
import { commonStore } from '../../stores/common';
import toastInfo from '../../components/Exam/toast_info.vue';
import { checkConnection } from '../../websockets/WebsocketVerification';
import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

const common = commonStore();
const props = defineProps({
	user: { type: Object, required: true },
	mock_biometry: { type: Boolean, required: true },
	allow_finger_change: { type: Boolean, required: false, default: false },
	enrollmentTest: { type: Object, required: true },
	finger: { type: Object, required: true },
	maximumRetries: { type: Number, required: true },
	listDvr: { type: Object, required: true },
	isWebcamOn: { type: Boolean, required: true },
	actionStoreBiometry: { type: String, required: true },
	actionCollectPhoto: { type: String, required: true },
	hasDvrCamOffline: { type: Boolean, required: true },
	requestBiometryUrl: { type: String, required: true },
	subtenantName: { type: String, required: true },
	is_ws_verification: { type: Boolean, required: true },
	computer_uid: { type: String, required: true },
	logout_url: { type: String, required: true },
	descricao_computer: { type: String, required: true },
	is_agent_support_ws_verification: { type: Boolean, required: true },
	spa_enabled: { type: Boolean, required: false, default: false },
	browser_webcam_streaming_enabled: {
		type: Boolean,
		required: false,
		default: false,
	},
	open_camera_route: { type: String, required: false, default: '' },
});

const browserWebcam = browserWebcamStreamingStore();
const loadingBiometry: Ref<boolean> = ref(false);
const biometryCompleted: Ref<boolean> = ref(false);
const biometryError: Ref<boolean> = ref(false);
const biometryResponse: Ref<ResponseAgentManagerBiometry | undefined> = ref();
const waitingBiometrySeconds: Ref<number> = ref(60);
const hasDvrCamOffline: Ref<boolean> = ref(props.hasDvrCamOffline);
const timeOut: Ref<number> = ref(60);
const showHighlightedHands = ref(true);
let handsBlinkInterval: NodeJS.Timeout | undefined;

const connectionSpinner = ref(true);
const connectionStatus = ref({
	connection: false,
	verified: false,
});

const url_params = new URLSearchParams(window.location.search);
const url_type_message = url_params.get('type');
const url_message = url_params.get('message');
const test_over =
	url_message && ['test-over', 'exam_timeout'].indexOf(url_message) !== -1;
const test_middle =
	url_type_message === 'info' && url_message === 'test-middle';

/**
 * Atalho de teclado para simulação de biometria.
 * Regra (tecla -> número do dedo):
 * 0 -> 10
 * 1 -> 9
 * 2 -> 8
 * 3 -> 7
 * 4 -> 6
 * 5 -> 1
 * 6 -> 2
 * 7 -> 3
 * 8 -> 4
 * 9 -> 5
 */
const selectedFingerNumber = ref<number>(
	Number(props.finger?.fingerNumber ?? 1)
);

const SIMULATION_KEY_TO_FINGER_NUMBER: Record<string, number> = {
	// Mapeamento do teclado (dígito) -> número do dedo
	'0': 10,
	'1': 9,
	'2': 8,
	'3': 7,
	'4': 6,
	'5': 1,
	'6': 2,
	'7': 3,
	'8': 4,
	'9': 5,
};

const fingerLabel = computed(() => {

	const labels: Record<number, string> = {
		1: 'POLEGAR DA MÃO DIREITA',
		2: 'INDICADOR DA MÃO DIREITA',
		3: 'MÉDIO DA MÃO DIREITA',
		4: 'ANELAR DA MÃO DIREITA',
		5: 'MÍNIMO DA MÃO DIREITA',
		6: 'POLEGAR DA MÃO ESQUERDA',
		7: 'INDICADOR DA MÃO ESQUERDA',
		8: 'MÉDIO DA MÃO ESQUERDA',
		9: 'ANELAR DA MÃO ESQUERDA',
		10: 'MÍNIMO DA MÃO ESQUERDA',
	};

	return labels[selectedFingerNumber.value] ?? String(props.finger?.finger ?? '');
});

watch(
	() => props.finger?.fingerNumber,
	(newFinger) => {
        selectedFingerNumber.value = Number(newFinger ?? 1);
	}
);

function shouldIgnoreKeyEvent(event: KeyboardEvent): boolean {
	const target = event.target as HTMLElement | null;
	if (!target) return false;
	const tag = target.tagName?.toLowerCase();
	return (
		tag === 'input' ||
		tag === 'textarea' ||
		(tag === 'select') ||
		(target as HTMLElement).isContentEditable
	);
}

function canChangeFingerViaKeyboard(): boolean {
	return (
		props.allow_finger_change &&
		(biometryStep.value === 'idle' || biometryStep.value === 'error')
	);
}

function onKeyDownChangeFinger(event: KeyboardEvent) {
	if (!canChangeFingerViaKeyboard()) return;
	if (shouldIgnoreKeyEvent(event)) return;
	if (event.key.length !== 1) return;
	if (!Object.prototype.hasOwnProperty.call(SIMULATION_KEY_TO_FINGER_NUMBER, event.key)) {
		return;
	}

	selectedFingerNumber.value = SIMULATION_KEY_TO_FINGER_NUMBER[event.key];
}

type BiometryStep = 'idle' | 'capturing' | 'success' | 'error';

const biometryPrimaryActionLabel = computed(() =>
    props.mock_biometry ? 'Simular biometria' : 'Coletar biometria'
);

const biometryStep = computed<BiometryStep>(() => {
	if (
		loadingBiometry.value &&
		!biometryCompleted.value &&
		!biometryError.value
	) {
		return 'capturing';
	}

	if (biometryCompleted.value && !biometryError.value) {
		return 'success';
	}





	if (biometryError.value) {
		return 'error';
	}

	return 'idle';
});

const highlightedHandsImageSrc = computed(() => {
	const fingerNumber = String(selectedFingerNumber.value).padStart(2, '0');

	return `/biometry-fingers/hands/${fingerNumber}.png`;
});

const neutralHandsImageSrc = computed(
	() => '/biometry-fingers/hands/both-hands.png'
);

onMounted(() => {
	if (
		props.browser_webcam_streaming_enabled &&
		!browserWebcam.isPublishing &&
		!browserWebcam.isMock
	) {
		router.visit(props.open_camera_route);
		return;
	}

	common.startKeyUp();
	window.addEventListener('keydown', onKeyDownChangeFinger);
	checkConnection(props, connectionStatus, connectionSpinner);

	setInterval(() => {
		checkConnection(props, connectionStatus, connectionSpinner);
	}, 5000);

	handsBlinkInterval = setInterval(() => {
		showHighlightedHands.value = !showHighlightedHands.value;
	}, 700);
});

onBeforeUnmount(() => {
	window.removeEventListener('keydown', onKeyDownChangeFinger);
	if (handsBlinkInterval) {
		clearInterval(handsBlinkInterval);
	}
});

function startBiometry() {
	waitingBiometrySeconds.value = 60;
	loadingBiometry.value = true;
	biometryError.value = false;
	biometryCompleted.value = false;

	var biometriyHandlerInterval: Ref<NodeJS.Timeout> = ref(
		setInterval(() => {
			if (waitingBiometrySeconds.value <= 0) {
				clearInterval(biometriyHandlerInterval.value);
			}
			waitingBiometrySeconds.value = waitingBiometrySeconds.value - 1;
		}, 1000)
	);

	axios
		.post(
			props.requestBiometryUrl,
			{
				enrollment_test_id: props.enrollmentTest.id,
				start_webcam: false,
				uid: props.enrollmentTest.uid,
			},
			{
				timeout: timeOut.value * 1000,
			}
		)
		.then((response: AxiosResponse<ResponseAgentManagerBiometry>) => {
			console.log(response.data);
			biometryResponse.value = response.data;
			biometryError.value = false;
			biometryCompleted.value = true;
			clearInterval(biometriyHandlerInterval.value);
		})
		.catch((response) => {
			if (props.mock_biometry) {
				biometryCompleted.value = true;
				biometryError.value = false;
			} else {
				biometryCompleted.value = false;
				biometryError.value = true;
			}
			clearInterval(biometriyHandlerInterval.value);
		});
}

function resetBiometry() {
	waitingBiometrySeconds.value = 60;
	loadingBiometry.value = false;
	biometryCompleted.value = false;
	biometryError.value = false;
	biometryResponse.value = undefined;
}

const imagePath = computed(() => {
	if (biometryResponse.value !== undefined) {
		return `data:image/jpeg;charset=utf-8;base64,${biometryResponse.value.data.img_jpeg}`;
	}
	return neutralHandsImageSrc.value;
});

function nextPage() {
	const payload: Record<string, any> = {
		responseBiometry: biometryResponse.value,
	};

	if (props.allow_finger_change) {
		payload.finger_number = selectedFingerNumber.value;
	}

	axios
		.post(props.actionStoreBiometry, payload)
		.then((response: AxiosResponse<Object>) => {
			if (props.spa_enabled) {
				router.visit(props.actionCollectPhoto);
				return;
			}
			window.location.href = props.actionCollectPhoto;
		});
}
</script>

<style scoped>
.exam-capture-page {
	--exam-action-font-size: 18px;
	--exam-action-min-height: 56px;
	--exam-card-padding-bottom: 0;
	--exam-card-padding-top: 15px;
	--exam-checklist-font-size: 19px;
	--exam-checklist-gap: 14px;
	--exam-checklist-padding-block: 14px;
	--exam-checklist-padding-inline: 16px;
	--exam-checklist-number-size: 34px;
	--exam-gap: 24px;
	--exam-heading-caption-size: 15px;
	--exam-heading-margin-bottom: 12px;
	--exam-instructions-lead-size: 20px;
	--exam-instructions-title-size: 30px;
	--exam-layout-padding-bottom: 26px;
	--exam-layout-padding-inline: 26px;
	--exam-logo-margin: 4rem;
	--exam-media-padding: 8px;
	--exam-page-title-size: 1.5rem;
	--exam-progressbar-icon-font-size: 18px;
	--exam-progressbar-icon-size: 50px;
	--exam-progressbar-line-top: 25px;
	--exam-progressbar-margin-bottom: 10px;
	--exam-progressbar-text-size: 12px;
}

.exam-logo-row {
	margin-bottom: var(--exam-logo-margin) !important;
	margin-top: var(--exam-logo-margin) !important;
}

.exam-card-body {
	padding: var(--exam-card-padding-top) 0 var(--exam-card-padding-bottom);
}

.exam-heading {
	margin-bottom: var(--exam-heading-margin-bottom);
}

.exam-heading h2 {
	font-size: var(--exam-page-title-size);
}

.exam-heading-caption {
	color: #747a7e;
	font-size: var(--exam-heading-caption-size);
}

#progressbar {
	margin-bottom: var(--exam-progressbar-margin-bottom);
}

#progressbar li {
	font-size: var(--exam-progressbar-text-size);
}

#progressbar li:before {
	font-size: var(--exam-progressbar-icon-font-size);
	height: var(--exam-progressbar-icon-size);
	line-height: calc(var(--exam-progressbar-icon-size) - 5px);
	margin-bottom: 8px;
	width: var(--exam-progressbar-icon-size);
}

#progressbar li:after {
	top: var(--exam-progressbar-line-top);
}

.exam-capture-layout {
	display: grid;
	grid-template-columns: minmax(0, 1.35fr) minmax(280px, 0.65fr);
	gap: var(--exam-gap);
	padding: 0 var(--exam-layout-padding-inline) var(--exam-layout-padding-bottom);
	text-align: left;
}

.exam-instructions,
.exam-capture-panel {
	min-width: 0;
}

.exam-step-label {
	color: #022d62;
	font-size: var(--exam-step-label-size, 16px);
	font-weight: 700;
	margin-bottom: var(--exam-step-label-margin-bottom, 6px);
	text-transform: uppercase;
}

.exam-instructions-title {
	color: #181c32;
	font-size: var(--exam-instructions-title-size);
	font-weight: 800;
	line-height: 1.2;
	margin-bottom: var(--exam-title-margin-bottom, 10px);
}

.exam-instructions-lead {
	color: #3f4254;
	font-size: var(--exam-instructions-lead-size);
	font-weight: 700;
	line-height: var(--exam-instructions-line-height, 1.45);
	margin-bottom: var(--exam-lead-margin-bottom, 20px);
}

.exam-checklist {
	display: grid;
	gap: var(--exam-checklist-gap);
}

.exam-checklist-item {
	align-items: center;
	background: #f5f8fa;
	border: 1px solid #e4e6ef;
	border-radius: 8px;
	color: #3f4254;
	display: flex;
	font-size: var(--exam-checklist-font-size);
	font-weight: 700;
	gap: var(--exam-checklist-item-gap, 12px);
	line-height: var(--exam-checklist-line-height, 1.45);
	padding: var(--exam-checklist-padding-block) var(--exam-checklist-padding-inline);
}

.exam-checklist-item strong {
	color: #022d62;
}

.exam-checklist-number {
	align-items: center;
	background: #022d62;
	border-radius: 999px;
	color: #ffffff;
	display: inline-flex;
	flex: 0 0 var(--exam-checklist-number-size);
	font-size: var(--exam-checklist-number-font-size, 18px);
	height: var(--exam-checklist-number-size);
	justify-content: center;
	width: var(--exam-checklist-number-size);
}

.exam-capture-panel {
	text-align: center;
}

.exam-media-box {
	align-items: center;
	aspect-ratio: 4 / 3;
	background: #d3d3d3;
	border: 1px solid #e4e6ef;
	border-radius: 10px;
	display: flex;
	justify-content: center;
	margin-bottom: var(--exam-media-margin-bottom, 18px);
	padding: var(--exam-media-padding);
	position: relative;
}

.exam-media-overlay {
	align-items: center;
	background: rgba(255, 255, 255, 0.76);
	border-radius: inherit;
	display: flex;
	inset: 0;
	justify-content: center;
	position: absolute;
}

.exam-finger-image {
	aspect-ratio: 4 / 3;
	border-radius: 8px;
	height: 100%;
	object-fit: contain;
	width: 100%;
}



.exam-hands-preview {
	aspect-ratio: 4 / 3;
	display: grid;
	height: auto;
	max-height: 100%;
	place-items: center;
	position: relative;
	width: 100%;
}

.exam-hands-image {
	grid-area: 1 / 1;
	left: 0;
	position: absolute;
	top: 0;
}

.exam-highlighted-hands-image {
	opacity: 0;
	transition: opacity 180ms ease-out;
}

.exam-highlighted-hands-image.is-visible {
	opacity: 1;
}

.exam-primary-action {
	align-items: center;
	display: inline-flex;
	font-size: var(--exam-action-font-size);
	font-weight: 800;
	gap: 10px;
	justify-content: center;
	min-height: var(--exam-action-min-height);
	white-space: normal;
}

.exam-secondary-action {
	align-items: center;
	display: inline-flex;
	font-size: var(--exam-action-font-size);
	font-weight: 800;
	gap: 10px;
	justify-content: center;
	min-height: var(--exam-action-min-height);
	white-space: normal;
}

.exam-success-actions {
	display: grid;
	gap: var(--exam-success-actions-gap, 10px);
}

@media (max-height: 760px) {
	.exam-capture-page {
		--exam-action-font-size: 16px;
		--exam-action-min-height: 48px;
		--exam-card-padding-top: 12px;
		--exam-checklist-font-size: 16px;
		--exam-checklist-gap: 10px;
		--exam-checklist-padding-block: 10px;
		--exam-checklist-padding-inline: 12px;
		--exam-checklist-number-size: 30px;
		--exam-gap: 18px;
		--exam-heading-margin-bottom: 8px;
		--exam-instructions-lead-size: 17px;
		--exam-instructions-title-size: 25px;
		--exam-layout-padding-bottom: 18px;
		--exam-layout-padding-inline: 20px;
		--exam-logo-margin: 2rem;
		--exam-media-margin-bottom: 12px;
		--exam-media-padding: 6px;
		--exam-page-title-size: 1.35rem;
		--exam-progressbar-icon-font-size: 16px;
		--exam-progressbar-icon-size: 42px;
		--exam-progressbar-line-top: 21px;
		--exam-progressbar-margin-bottom: 6px;
		--exam-progressbar-text-size: 11px;
	}
}

@media (max-height: 680px) {
	.exam-capture-page {
		--exam-action-font-size: 15px;
		--exam-action-min-height: 44px;
		--exam-card-padding-top: 10px;
		--exam-checklist-font-size: 15px;
		--exam-checklist-gap: 8px;
		--exam-checklist-padding-block: 8px;
		--exam-checklist-padding-inline: 10px;
		--exam-checklist-number-size: 28px;
		--exam-gap: 14px;
		--exam-heading-caption-size: 14px;
		--exam-heading-margin-bottom: 6px;
		--exam-instructions-lead-size: 15px;
		--exam-instructions-title-size: 22px;
		--exam-layout-padding-bottom: 12px;
		--exam-lead-margin-bottom: 12px;
		--exam-logo-margin: 1rem;
		--exam-media-margin-bottom: 10px;
		--exam-media-padding: 4px;
		--exam-page-title-size: 1.2rem;
		--exam-progressbar-icon-font-size: 14px;
		--exam-progressbar-icon-size: 36px;
		--exam-progressbar-line-top: 18px;
		--exam-progressbar-margin-bottom: 4px;
		--exam-progressbar-text-size: 10px;
		--exam-step-label-size: 14px;
	}
}

@media (max-height: 620px) {
	.exam-capture-page {
		--exam-action-font-size: 14px;
		--exam-action-min-height: 40px;
		--exam-card-padding-top: 8px;
		--exam-checklist-font-size: 13px;
		--exam-checklist-gap: 6px;
		--exam-checklist-item-gap: 8px;
		--exam-checklist-line-height: 1.25;
		--exam-checklist-number-font-size: 13px;
		--exam-checklist-number-size: 24px;
		--exam-checklist-padding-block: 6px;
		--exam-checklist-padding-inline: 8px;
		--exam-gap: 10px;
		--exam-heading-margin-bottom: 4px;
		--exam-instructions-lead-size: 13px;
		--exam-instructions-line-height: 1.3;
		--exam-instructions-title-size: 19px;
		--exam-layout-padding-bottom: 8px;
		--exam-layout-padding-inline: 14px;
		--exam-lead-margin-bottom: 8px;
		--exam-logo-margin: 0.5rem;
		--exam-media-margin-bottom: 8px;
		--exam-media-padding: 3px;
		--exam-page-title-size: 1rem;
		--exam-progressbar-icon-font-size: 12px;
		--exam-progressbar-icon-size: 30px;
		--exam-progressbar-line-top: 15px;
		--exam-progressbar-margin-bottom: 2px;
		--exam-progressbar-text-size: 9px;
		--exam-step-label-margin-bottom: 2px;
		--exam-step-label-size: 12px;
		--exam-success-actions-gap: 6px;
		--exam-title-margin-bottom: 6px;
	}

	.exam-heading-caption {
		display: none;
	}
}

</style>
